module.exports = __webpack_public_path__ + "static/example_month_span_multiple_pages-f2575ccf408f3bd993fc14a401c06106.png";